export const estoqueKeyFactory = {
  allFromRede: (cnpjMatriz) => [{ scope: 'estoque', cnpjMatriz }],
  filteredFromRede: (cnpjMatriz, filters = {}) => [
    { ...estoqueKeyFactory.allFromRede(cnpjMatriz)[0], ...filters },
  ],
};
